import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

// local imports
import successImage from 'assets/images/success-image.svg'
import DateUtil from 'utils/DateUtil'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import { useGetDoctorList } from 'components/home/on-campus-services/health-service/hooks'
import NotificationDialog from 'components/ui/NotificationDialog'
import AppointmentModalWrapper from 'components/home/on-campus-services/health-service/appointment-scheduler/AppointmentModal'
import LoadingWrapper from './LoadingWrapper'

/* constants & types */
const today = DateUtil.getStartOfDay(new Date())
interface CompProps {
  locationId: number
  id: number
  setReservationType: (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => void
}

export default function DoctorRes({ id, locationId, setReservationType }: CompProps) {
  const { t } = useTranslation()
  const history = useHistory()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const openModal = () => setModal(true)
  const closeModal = (resetRes = false) => {
    setModal(false)
    if (resetRes) setReservationType(0, undefined)()
  }
  const closeNotification = () => {
    setNotification(false)
    setReservationType(0, undefined)()
  }

  /* Get Doctor List Get Doctors Specialties - Locations | Custom Hooks */
  const { getDoctorList, doctors, loading } = useGetDoctorList()
  const _selectedDoc = doctors.find((r) => r.healthServiceDoctorId === id)
  const [selectedDoc, setSelectedDoc] = useState(() => _selectedDoc)
  useEffect(() => {
    getDoctorList({ locationIds: [locationId], reservationDate: today, specialtyId: 0 })
    openModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, locationId])

  if (loading) return <LoadingWrapper />

  return (
    <>
      {/* Doctor Appointment Modal */}
      {!!_selectedDoc ? (
        <AppointmentModalWrapper
          doctors={doctors}
          open={modal}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => setNotification(true)}
          setSelectedDoc={setSelectedDoc}
          selectedDoc={selectedDoc || _selectedDoc}
          filterDate={today}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('appointment-modal.notification-title')}
        content={t('appointment-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={closeNotification}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
